import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore } from '../../store';
import { getTimelineList } from '../../service';
import { enrichNodesWithCounts } from '@src/public/services/interactionCounts';
import styles from './index.css';
import LiveNotice from './LiveNotice';

const cx = classNames.bind(styles);

const Filter = ({ id, noticeText }) => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { size, party, highlights, order, parties, allFold, navHeight, nodeFoldList } = listStates;

    const handleTabClick = async newParty => {
        if (window && window.timelineReset) {
            window.timelineReset();
        }

        if (newParty !== party) {
            changeListStates({ nodes: [], party: newParty });

            try {
                const initPage = 1;
                const res = await getTimelineList({
                    id,
                    page: initPage,
                    size,
                    party: newParty,
                    highlights,
                    order,
                });
                const { nodes: rawNodes = [], pagination } = res;
                const { total } = pagination;
                const nodes = await enrichNodesWithCounts(rawNodes);

                changeListStates({ nodes, page: initPage + 1, total });
            } catch (e) {
                console.error(e);
            }
        }
    };

    const handleHighlightsClick = async () => {
        const newHighlights = highlights === 1 ? 0 : 1;

        changeListStates({ nodes: [], highlights: newHighlights });

        try {
            const initPage = 1;
            const res = await getTimelineList({
                id,
                page: initPage,
                size,
                party,
                highlights: newHighlights,
                order,
            });
            const { nodes: rawNodes = [], pagination } = res;
            const { total } = pagination;
            const nodes = await enrichNodesWithCounts(rawNodes);

            changeListStates({ nodes, page: initPage + 1, total });
        } catch (e) {
            console.error(e);
        }
    };

    const handleSortClick = async () => {
        if (order === '') {
            return;
        }
        if (window && window.timelineReset) {
            window.timelineReset();
        }
        const newOrder = order === 'asc' ? 'desc' : 'asc';

        changeListStates({ nodes: [], order: newOrder });

        try {
            const initPage = 1;
            const res = await getTimelineList({
                id,
                page: initPage,
                size,
                party,
                highlights,
                order: newOrder,
            });
            const { nodes: rawNodes = [], pagination } = res;
            const { total } = pagination;
            const nodes = await enrichNodesWithCounts(rawNodes);

            changeListStates({ nodes, page: initPage + 1, total });
        } catch (e) {
            console.error(e);
        }
    };

    const handleFoldClick = () => {
        changeListStates({ allFold: !allFold });
    };

    const tagListRef = useRef();
    const [showMoreArrow, setShowMoreArrow] = useState(false);
    const [showMore, setShowMore] = useState(false);

    useEffect(
        () => {
            if (parties.length) {
                setShowMoreArrow(false);
                setShowMore(false);

                const offsetW = tagListRef.current.offsetWidth;
                const scrollW = tagListRef.current.scrollWidth;

                if (scrollW > offsetW) {
                    setShowMoreArrow(true);
                }
            }
        },
        [parties],
    );

    return (
        <>
            <div
                className={cx('tagWrap', { tagWrapMore: showMore, tagWrapArrow: showMoreArrow })}
                style={{ top: navHeight }}>
                {showMoreArrow ? (
                    <div
                        className={styles.tagMoreArrow}
                        onClick={() => {
                            setShowMore(prev => !prev);
                        }}>
                        {showMore ? '收起' : '全部'}
                    </div>
                ) : null}

                <div className={styles.tagList} ref={tagListRef}>
                    {parties.map(item => {
                        const { id, name, color } = item;
                        const current = id === party;

                        return (
                            <div
                                className={styles.tag}
                                key={id}
                                style={
                                    current
                                        ? {
                                              borderColor: color,
                                              backgroundColor: color,
                                              color: '#fff',
                                          }
                                        : {
                                              borderColor: color,
                                              backgroundColor: '#fff',
                                              color,
                                          }
                                }
                                onClick={() => {
                                    handleTabClick(id);
                                }}>
                                <div>{name}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {noticeText ? <LiveNotice content={{ noticeText }} /> : null}
            <div className={styles.actionWrap}>
                <div className={styles.actionLeft}>
                    <div
                        className={cx('highlights', { highlightsOnly: highlights === 1 })}
                        onClick={handleHighlightsClick}>
                        <div className={styles.iconPoint} />
                        <div>看重点</div>
                    </div>
                    <div className={styles.foldWrap} onClick={handleFoldClick}>
                        <div className={cx('foldIcon', { allFoldIcon: allFold })} />
                        {allFold ? '全部展开' : '全部收起'}
                    </div>
                </div>
                <div className={styles.actionRight}>
                    <div className={styles.sortWrap} onClick={handleSortClick}>
                        <div className={`${styles.sortBtn} ${order === 'asc' ? styles.sortbtnCurrent : ''}`}>正序</div>
                        <div className={`${styles.sortBtn} ${order === 'desc' ? styles.sortbtnCurrent : ''}`}>倒序</div>
                    </div>
                </div>
            </div>
        </>
    );
};

Filter.propTypes = {
    id: PropTypes.string,
    noticeText: PropTypes.string,
};

export default errorBoundary(Filter);
